<template>
  <div id="insurance-page">
    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/insurances'">保险商城</router-link>
    </div>

    <div class="all-insurance">

      <div class="nav-box">
        <div class="nav-type-box">
          <div @click="changeFirstClass(0)" id="type-item-0" class="type-item" :class="{active: params.first_class === 0}">全部</div>
          <div
            @click="changeFirstClass(item)"
            class="type-item"
            :class="{active: item === params.first_class}"
            :id="`type-item-${item}`"
            v-for="item in first_class_set"
            :key="item"
          >{{insuranceCategory[item].label}}</div>
          <div class="nav-type-bar" :style="{'left': `${tabLeft}px`,}"></div>
        </div>
        <div class="nav-region-box" v-if="second_class_set.length">
          <div class="region-item"  @click="changeSecondClass(0)" :class="{active: 0 === params.second_class}">不限</div>
          <div
            @click="changeSecondClass(item)"
            class="region-item"
            :class="{active: item === params.second_class}"
            v-for="item in second_class_set"
            :key="item"
          >{{insuranceCategory[params.first_class] && insuranceCategory[params.first_class].children[item]}}</div>
        </div>
        <div class="sort-box">
          <div class="sort-item" :class="{active: params.sort_field === ''}" @click="changeSort('')">
            <div class="value">综合</div>
          </div>
          <div class="sort-item" :class="{active: params.sort_field === 'sales'}" @click="changeSort('sales')">
            <div class="value">销量</div>
            <div class="order-icon" :class="params.sort_field === 'sales' ? params.sort_order : 'desc'"></div>
          </div>
          <div class="sort-item" :class="{active: params.sort_field === 'price*discount'}" @click="changeSort('price*discount')">
            <div class="value">价格</div>
            <div class="order-icon" :class="params.sort_field === 'price*discount' ? params.sort_order : 'desc'"></div>
          </div>
        </div>
      </div>

      <ul class="insurance-product-items">
        <li class="product-item" v-for="insurance in insuranceList" :key="insurance.id" @click="goInsuranceDetail(insurance.id)">
          <div class="region-img">
            <div>
              <img class="region-logo" :src="insurance.cover">
            </div>
            <div class="recommend-icon" v-if="insurance.top_status === 1"></div>
          </div>
          <div class="detail">
            <div class="product-info">
              <div class="product-title-box">
                <div class="product-title">{{insurance.insurance_name}}</div>

                <div class="product-logo">
                  <img class="logo" :src="insurance.company_logo">
                </div>
              </div>
              <div class="product-detail-list">
                <div class="product-detail-item" v-for="(feature, index) in filterTrueArray(insurance.description)" :key="index">
                  <div class="icon"></div>
                  {{feature}}
                </div>
              </div>
            </div>
            <div class="product-bottom">
              <div class="product-price-box" v-show="!User.isLogin()"></div>
              <div class="product-price-box" v-show="User.isLogin()">
                <div class="product-price">
                  <span class="currency">￥</span>
                  <!-- <span class="price">{{formatPrice(insurance.price * (insurance.discount / 10))}}</span> -->
                  <span class="price">{{formatPrice(insurance.price)}}</span>
                  <span class="unit">起</span>
                </div>
                <!-- <div class="product-discount" v-if="insurance.discount !== 10">
                  {{insurance.discount}}折
                </div> -->
                <!-- <div class="product-original-price" v-if="insurance.discount !== 10">
                  <span class="label">原价</span>
                  <span class="price">￥{{insurance.price / 100}}</span>
                </div> -->

              </div>
              <div class="product-btn-box">
                <div class="product-btn s-btn btn-lg btn-orange is-round">立即办理</div>
              </div>
            </div>
          </div>
        </li>
        <div class="page">
          <el-pagination class="text-center" @current-change="pageChange" :current-page="params.page"
            :page-size="6" layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </ul>

    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import sensorsdata from 'sa-sdk-javascript';
import { ENTER_INSURANCE } from '../maps/sensors-maps';
import { insuranceCategory } from '../constants/insurance-constants';
import User from '../libs/user.js';
import Http from '../libs/http';

export default {
  name: 'insurances',
  data() {
    return {
      insuranceCategory,
      insuranceList: [],
      first_class_set: [],
      second_class_set: [],
      total: 0,
      params: {
        page: 1,
        first_class: 0,
        second_class: 0,
        sort_field: '',
        sort_order: '',
      },
      User,
      tabLeft: 0,
      from: '',
    };
  },
  computed: {
  },
  watch: {
    $route(to) {
      // 这里 watch $route 是为了解决在旅游保险页面点击右侧浮窗中的旅游保险时页面 tab 不切换的问题（因为是在相同路由跳转，只是参数发生了变化）。
      if (to.query && to.query.first_class !== this.params.first_class) {
        this.init();
      }
    },
    params: {
      handler() {
        this.addQueryToUrl();
      },
      deep: true,
    },
  },
  created() {
    this.init();
    this.sensorDataLog();
  },
  mounted() {
    this.computedNavLeft();
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    init() {
      const query = this.$route.query || {};
      this.params.page = +query.page || 1;
      this.params.first_class = +query.first_class || 0;
      this.params.second_class = +query.second_class || 0;
      this.params.sort_field = +query.sort_field || '';
      this.params.sort_order = +query.sort_order || '';
      this.from = query.from || '';
      // 获取保险数据
      this.getInsurancePageData();
    },

    goInsuranceDetail(id) {
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'insurance_list' });
        return;
      }
      MtaH5.clickStat('buyinsurance');
      this.$router.push({ name: 'insuranceDetail', params: { id } });
    },

    /**
     * 获取当前页面的保险列表销量数据
     */
    getInsurancePageData() {
      Http.post('/sys/insurance_product_brief_query', {
        page: this.params.page,
        first_class: +this.params.first_class || undefined,
        second_class: +this.params.second_class || undefined,
        sort: this.params.sort_field ? `${this.params.sort_field} ${this.params.sort_order}` : undefined,
      }).then((res) => {
        this.first_class_set = res.first_class_set;
        this.second_class_set = res.second_class_set;
        this.total = res.total_count;
        this.insuranceList = res.page_data;
        if (!res.page_data.length) {
          // 不支持这个这个筛选，就回复到全部
          this.changeFirstClass(0);
        }
        this.$nextTick(() => {
          this.computedNavLeft();
        });
      });
    },
    pageChange(page) {
      this.params.page = page;
      this.getInsurancePageData();
    },
    changeFirstClass(first_class) {
      this.params.first_class = first_class;
      this.params.page = 1;
      this.params.second_class = 0;
      this.computedNavLeft();
      this.getInsurancePageData();
    },
    changeSecondClass(second_class) {
      this.params.second_class = second_class;
      this.params.page = 1;
      this.getInsurancePageData();
    },
    changeSort(field) {
      if (field !== this.params.sort_field) {
        this.params.sort_field = field;
        this.params.sort_order = field === 'price*discount' ? 'asc' : 'desc';
      } else if (field) {
        this.params.sort_order = this.params.sort_order === 'desc' ? 'asc' : 'desc';
      }
      this.params.page = 1;
      this.getInsurancePageData();
    },
    computedNavLeft() {
      const itemEl = document.querySelector(`#type-item-${this.params.first_class}`);
      if (!itemEl) return;
      this.tabLeft = itemEl.offsetLeft + itemEl.offsetWidth / 2 - 15;
    },
    addQueryToUrl() {
      const query = this.params;
      query.from = this.from;
      this.$router.replace({ query });
    },
    // 神策埋点
    sensorDataLog() {
      sensorsdata.track('Enter_the_insurance_mall', {
        Travel_insurance_source: this.from ? ENTER_INSURANCE[this.from] : '',
        peer_name: User.peer.peer_name,
        visa_peer_id: User.peer.visa_peer_id,
      });
    },
    filterTrueArray(list) {
      return list.filter(item => item);
    },
    formatPrice(price) {
      return Number((price / 100).toFixed(2), 10);
    },
  },

};
</script>

<style lang="less" scoped>
@import "../assets/less/variable";

#insurance-page {
  width: 1120px;
  margin: 0 auto 60px auto;
  .bread-item {
    color: black;
  }
  .all-insurance {
    // background-color: #fff;
    // box-shadow: 0 0 4px #edeef0;
    // padding: 0 30px 30px;
    .nav-box{
      background: #fff;
      box-shadow:0px 2px 4px 0px rgba(0,0,0,0.06);
      border-radius:2px;
      overflow: hidden;
      margin-bottom: 12px;
      .nav-type-box{
        height: 60px;
        width: 100%;
        position: relative;
        display: flex;
        padding: 0 32px;
        border-bottom: 1px solid #F0F0F0;
        .type-item{
          color: #6F6F6F;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin-right: 50px;
          &.active{
            color: #599FFF;
            font-weight: 600;
          }
        }
        .nav-type-bar{
          position: absolute;
          left: 0;
          bottom: 0;
          width:30px;
          height:4px;
          border-radius: 1px;
          background: #599fff;
          transition: 0.2s all;
        }
      }
      .nav-region-box{
        display: flex;
        align-items: center;
        height: 60px;
        background: #FFFFFF;
        padding: 0 32px;
        border-bottom: 1px solid #F0F0F0;
        .region-item{
          color: #444;
          font-size: 14px;
          margin-right: 32px;
          cursor: pointer;
          &.active{
            color: #599FFF;
            font-weight: 600;
          }
        }
      }
      .sort-box{
        height: 45px;
        display: flex;
        align-items: center;
        padding: 0 32px;
        background: #FAFBFC;
        .sort-item{
          margin-right: 32px;
          display: flex;
          align-items: center;
          cursor: pointer;
          user-select: none;
          .value{
            font-size: 14px;
            color: #5F666E;
            line-height: 1;
          }
          .order-icon{
            margin-left: 2px;
            width: 7px;
            height: 11px;
            background: url(../assets/imgs/insurance-new/order-gray.png) no-repeat center / 100% 100%;
            &.asc{
              transform: rotate(180deg);
            }
          }
          &.active{
            .value{
              color: #599FFF;
              font-weight: 600;
            }
            .order-icon{
              background: url(../assets/imgs/insurance-new/order-blue.png) no-repeat center / 100% 100%;
            }
          }
        }
      }
    }

    .insurance-product-items {
      .product-item {
        display: flex;
        padding: 20px 0 0 20px;
        box-shadow:0px 2px 4px 0px rgba(0,0,0,0.06);
        border-radius:2px;
        background: #fff;
        margin-bottom: 12px;
        cursor: pointer;
        transition: 0.2s all;
        &:hover{
          transform: translateY(-4px);
        }
        .region-img {
          flex-shrink: 0;
          width: 320px;
          height: 192px;
          position: relative;
          .region-logo {
            width: 320px;
            height: 192px;
          }
          .recommend-icon{
            width: 62px;
            height: 69px;
            position: absolute;
            right: 0;
            top: -4px;
            z-index: 1;
            background: url(../assets/imgs/insurance-new/icon-recommend.png) no-repeat center /  100% 100%;
          }
        }
        .detail {
          flex: 1;
          line-height: 1;
          margin-left: 24px;
          overflow: hidden;
          padding-bottom: 36px;
          padding-right: 20px;
          .product-info{
            .product-title-box{
              display: flex;
              align-items: center;
              margin-bottom: 12px;
              .product-title{
                flex-grow: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 24px;
                line-height: 28px;
                color: #2F333D;
                font-weight: 600;
              }
              .product-logo{
                margin-left: 24px;
                flex-shrink: 0;
                .logo{
                  height: 36px;
                }
              }
            }
            .product-detail-list{
              font-size: 14px;
              line-height: 1;
              height: 74px;
              .product-detail-item{
                margin-bottom: 16px;
                display: flex;
                align-items: center;
                font-size: 14px;
                line-height: 1;
                color: #5F666E;
                .icon{
                  width: 12px;
                  height: 12px;
                  background: url(../assets/imgs/insurance-new/icon-desc.png)  no-repeat center / 100% 100%;
                  margin-right: 4px;
                }
                &:last-child{
                  margin-bottom: 0;
                }
              }
            }
          }
          .product-bottom{
            flex-shrink: 0;
            margin-top: 12px;
            display: flex;
            .product-price-box{
              display: flex;
              align-items: flex-end;
              flex-shrink: 0;
              flex-grow: 1;
              .product-price{
                color: #FF8033;
                display: flex;
                align-items: flex-end;
                line-height: 1;
                .currency{
                  font-size: 24px;
                  font-weight: 600;
                  line-height: 20px;
                }
                .price{
                  font-size: 36px;
                  font-weight: 600;
                  line-height: 26px;
                }
                .unit{
                  font-size: 14px;
                  margin-left: 4px;
                }
              }
              .product-discount{
                margin-left: 8px;
                height: 24px;
                padding: 0 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                background:linear-gradient(90deg,rgba(255,134,53,1) 0%,rgba(255,159,62,1) 100%);
                border-radius:2px;
                font-size: 16px;
                line-height: 1;
                color: #fff;
              }
              .product-original-price{
                font-size: 14px;
                color: #91999F;
                display: flex;
                align-items: baseline;
                margin-left: 8px;
                .label{
                  margin-right: 0;
                }
                .price{
                  text-decoration: line-through;
                }
              }

            }
            .product-btn-box{
              .product-btn{
                // width: 132px;
                box-shadow:0px 12px 20px -8px rgba(255,128,51,0.5);
              }
            }

          }
        }
      }
    }
    .page {
      padding: 24px 30px 24px 30px;
      /deep/ .el-pagination__total{
        line-height: 32px;
        height: 32px;
      }
    }
  }
}
</style>
<style lang="less">
#insurance-page {
  .page {
    .number {
      width: 32px;
      height: 32px;
      line-height: 32px;
    }
    button {
      line-height: 32px;
      height: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Insurances.vue